/**
 * Drive's thumbnail URL flattens a transparent PNG onto black.
 * s800 is large enough that Google still returns the PNG with its transparency.
 */
export function displayDrivePhoto(url) {
  const raw = String(url || '').trim();
  const match = raw.match(/(?:[?&]id=|\/d\/)([a-zA-Z0-9_-]{10,})/);
  if (!match) return raw;
  return `https://lh3.googleusercontent.com/d/${match[1]}=s800`;
}

/**
 * Photo to show for a proposal line.
 * A unique catalog name uses the current catalog photo.
 * Saved price, quantity, dimensions, and the stored imageUrl are left untouched.
 * Two catalog rows with the same name, or a name that is not in the catalog, keep the stored photo.
 */
export function proposalProductImageUrl(product, catalog) {
  const stored = String(product?.imageUrl || '').trim();
  const want = String(product?.name || '').trim().toLowerCase();
  if (!want || !Array.isArray(catalog) || catalog.length === 0) return displayDrivePhoto(stored);
  const matches = [];
  for (const row of catalog) {
    const name = String(row?.name || '').trim().toLowerCase();
    if (name && name === want) matches.push(row);
    if (matches.length > 1) break;
  }
  if (matches.length !== 1) return displayDrivePhoto(stored);
  const current = String(matches[0]?.imageUrl || '').trim();
  return displayDrivePhoto(current || stored);
}
